interface ComparativeInputData {
  readonly salarioBruto: string;
  readonly numeroDependentes: string;
  readonly dependentesMenores14: string;
  readonly valeAlimentacao: string;
  readonly valeTransporte: string;
  readonly planoSaude: string;
  readonly outrosBeneficios: string;
  readonly plr: string;
  readonly regimePJ: 'mei' | 'simples' | 'presumido';
}

interface CLTResultType {
  readonly salarioBruto: number;
  readonly salarioLiquido: number;
  readonly inss: number;
  readonly irrf: number;
  readonly salarioFamilia: number;
  readonly salarios12x: number;
  readonly decimoTerceiro: number;
  readonly ferias: number;
  readonly fgts: number;
  readonly plr: number;
  readonly beneficiosAnuais: number;
  readonly totalAnual: number;
  readonly equivalenciaMensal: number;
}

interface PJNecessarioType {
  readonly erro: boolean;
  readonly mensagem?: string;
  readonly regime: string;
  readonly minimo: number;
  readonly recomendado: number;
  readonly impostos: number;
  readonly aliquota: number;
  readonly margemPercent: number;
  readonly proLabore: number;
  readonly inssProLabore: number;
  readonly irrfProLabore: number;
}

interface AnaliseType {
  readonly vantagens: string[];
  readonly desvantagens: string[];
  readonly recomendacao: string;
}

interface CalculoBreakdown {
  readonly faixas: Array<{
    readonly limite: number;
    readonly aliquota: number;
    readonly valorFaixa: number;
    readonly contribuicaoFaixa: number;
    readonly limiteInicial: number;
    readonly limiteFinal: number;
  }>;
  readonly valorTotal: number;
  readonly baseCalculo: number;
}

interface FeriasBreakdown {
  readonly salarioFerias: number;
  readonly umTercoFerias: number;
  readonly brutoFerias: number;
  readonly inssFerias: number;
  readonly irrfFerias: number;
  readonly feriasLiquidas: number;
}

type ComparativeResultsType = {
  readonly cltResult: CLTResultType;
  readonly pjNecessario: PJNecessarioType;
  readonly diferenciaMensal: number;
  readonly percentualDiferenca: number;
  readonly analise: AnaliseType;
};

// Mensagens de validação
const ValidationMessages = {
  SALARIO_OBRIGATORIO: "Informe o salário bruto CLT.",
  SALARIO_INVALIDO: "Salário bruto deve ser maior que zero.",
  DEPENDENTES_INVALIDOS: "Dependentes menores não pode exceder total de dependentes.",
  LIMITE_MEI_EXCEDIDO: "Equivalência excede limite MEI. Considere o Simples Nacional.",
  ERRO_CALCULO: "Erro no cálculo. Verifique os dados informados.",
} as const;

// Constantes trabalhistas 2025
const CONSTANTES_2025 = {
  SALARIO_MINIMO: 1518.00,
  TETO_INSS: 8157.41,
  VALOR_DEPENDENTE_IRRF: 189.59,
  SALARIO_FAMILIA: 65.00,
  TETO_SALARIO_FAMILIA: 1906.04,
  FGTS_ALIQUOTA: 0.08,
  PLR_LIMITE_ISENCAO: 7640.80,
} as const;

export type {
  ComparativeResultsType,
  ComparativeInputData,
  CLTResultType,
  PJNecessarioType,
  AnaliseType,
  CalculoBreakdown,
  FeriasBreakdown,
};

export { ValidationMessages, CONSTANTES_2025 };